import React, { createContext, useContext, useState } from "react";

// Create the context
const VendorContext = createContext();

// Custom hook to use VendorContext
export const useVendor = () => useContext(VendorContext);

export const VendorProvider = ({ children }) => {
  const [vendorData, setVendorData] = useState(null);
  const [likedEvents, setLikedEvents] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [reviewsNewData, setReviewsNewData] = useState(null);
  const [tags, setTags] = useState([]);
  const [averageRating, setAverageRating] = useState(0);
  // Function to fetch vendor details
  const fetchVendorDetails = async (vendorId, userId) => {
    try {
      const response = await fetch(
        `https://xae0-ycmh-cnpt.n7c.xano.io/api:cyRcmRX9/vendors/get_vendors_details?vendor_profiles_id=${vendorId}&userId=${userId}`
      );
      const reviewResponse = await fetch(
        `https://xae0-ycmh-cnpt.n7c.xano.io/api:cyRcmRX9/vendors/myratings?vendor_profiles_id=${vendorId}&page=1&per_page=2000000`
      );
      const data = await response.json();
      const reviewData = await reviewResponse.json();
      setVendorData(data.data);

      // Process liked events
      const events = data.data.liked_events_of_users?.items.map(
        (item) => item.event[0]
      );
      setLikedEvents(events || []);

      // Set average rating from `Ratings_Rating` in API response
      const ratingData = data.data.average_rating?.Ratings_Rating;
      setAverageRating(ratingData || 0); // Default to 0 if no rating

      // Process reviews and tags
      const reviewsData = reviewData.data.ratings?.items;
      setReviewsNewData(reviewsData);
      const tagsData = data.data.tags
        ?.split(",")
        .map((tag) => tag.trim())
        .filter((tag) => tag.length > 0);
      setReviews(reviewsData);
      setTags(tagsData || []);
    } catch (error) {
      console.error("Error fetching vendor data:", error);
    }
  };

  return (
    <VendorContext.Provider
      value={{
        reviewsNewData,
        vendorData,
        likedEvents,
        reviews,
        averageRating,
        tags,
        fetchVendorDetails,
      }}
    >
      {children}
    </VendorContext.Provider>
  );
};
